import styled from "styled-components";

export const ActionTagContainer = styled.div<{ hasMarginLeft: boolean }>`
  width: 125px;
  height: 24px;

  margin-left: ${(props) => (props.hasMarginLeft ? "0" : "24px")};

  border-radius: 4px;

  padding: 4px 8px 4px 8px;

  font-weight: 700;
  font-size: 14px;

  background-color: #E02828;
  color: #FFFFFF;

  cursor: pointer;
  user-select: none;
`;